import React, { useState } from "react";
import styles from "./termsConditionPO.module.css";
import { Markup } from "interweave";

export const TermsConditionPO = ({ terms_and_conditions }) => {
  const [show, setShow] = useState(true);
  return (
    <div>
      <div className={styles.basicInfoDivPOCard}>
        <div className={styles.BasicInfoTopPOCard}>
          <div className={styles.basicInfoTopImgPOCard}>
            <div>
              <img src="./images/stratum/tandc.svg" alt="" />
            </div>
            <h6>Terms & Conditions</h6>
          </div>

          <img
            src="/images/upArrow.png"
            className={!show ? styles.rotateSvg : ""}
            alt=""
            onClick={() => setShow(!show)}
          />
        </div>

        {show && (
          <>
            <div className={styles.basicInfoDetailPOCard}>
              <p><Markup content={terms_and_conditions} /></p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
